import { render, staticRenderFns } from "./DetailsTemplate.vue?vue&type=template&id=04de939c&scoped=true&"
import script from "./DetailsTemplate.vue?vue&type=script&lang=js&"
export * from "./DetailsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTemplate.vue?vue&type=style&index=0&id=04de939c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04de939c",
  null
  
)

export default component.exports